<template>
  <div class="input-wrapper" :class="{ 'input--has--value': isChecked }">
    <label :for="id" class="input--checkbox">
      <input
        :id="id"
        type="checkbox"
        :name="name"
        :checked="checked"
        @change="ifChecked"
        @input="$emit('input',$event.target.value)"
        :class="classes"
      />
      <div class="input--checkbox--check"></div>
      {{label}}
      <span v-if="icon" class="input--checkbox--icon" v-html="icon"></span>
    </label>
  </div>
</template>

<script>

export default {
  name: 'Checkbox',
  data: () => ({
    isChecked: null
  }),
  components: {
  },
  computed: {
  },
  props: {
    id: { type: String , required: false, default: null },
    value: { type: Array, required: false, default: null },
    label: { type: String, required: false, default: null },
    name: { type: String, required: false, default: null },
    checked: { type: Boolean, required: false, default: false },
    classes: { type: String, required: false, default: null },
    required: { type: String, required: false, default: null },
    icon: { type: String, required: false, default: null }
  },
  mounted () {
  },
  created () {
  },
  methods: {
    ifChecked (event) {
      if (event.target.checked) {
         this.isChecked = true
      } else {
        this.isChecked = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../../scss/global/includes";


.input-wrapper {
    width: 100%;
    max-width: 100%;
    display: block;
    position: relative;
    margin-bottom: 5px;
    color: $primary-grey;

  &.input--has--value {

    .input--checkbox--icon ::v-deep [fill] {
      fill: $primary-grey;
    }

    .input--checkbox--icon ::v-deep [stroke] {
      stroke: $primary-grey;
    }

    .input--checkbox { 
      border: 1px solid $primary-grey;
      color: $primary-grey;
    }
  }

}

.input-wrapper .input--checkbox input {
  visibility: hidden;
  width: 0px;
  height: 0px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  line-height: 0;
  appearance: none;

  &:checked + div.input--checkbox--check {
    border: 1px solid $primary;
    &:after {
      margin-top: -2px;
      width: 4px;
      display: block;
      height: 8px;
      border: solid $primary;
      border-width: 0 1px 1px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
      content: "";
    }
  }
}

.input-wrapper .input--checkbox {
  display: flex;
  font-size: 16px;
  align-items: center;
  height: 44px;
  background-color: #ffffff;
  overflow: visible;
  border-radius: 4px;
  border: 1px solid $primary-grey;
  padding: 10px;
}

.input--checkbox--check {
  margin-left: 0px;
  width: 14px;
  height: 14px;
  margin-top: 0px;
  background: transparent;
  border: 1px solid $primary-grey;
  margin-right: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input--checkbox--icon {
  position: absolute;
  top: 8px;
  right: 8px;
}


</style>
